import { render, staticRenderFns } from "./uf_marker_products.vue?vue&type=template&id=ff952b66&scoped=true"
import script from "./uf_marker_products.vue?vue&type=script&lang=js"
export * from "./uf_marker_products.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff952b66",
  null
  
)

export default component.exports